var _filter, _filter2, _rect, _circle, _circle2, _circle3, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle4, _circle5, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _circle6, _path4, _path5, _path6, _circle7, _circle8, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleSessionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fef3c7",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#fbbf24",
      stopOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#dbeafe",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#3b82f6",
      stopOpacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f8fafc",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "dropShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 3,
    floodColor: "#000000",
    floodOpacity: 0.1
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18,
    width: 42,
    height: 32,
    rx: 3,
    ry: 3,
    fill: "url(#bgGradient1)",
    stroke: "#f59e0b",
    strokeWidth: 1.5,
    filter: "url(#dropShadow)",
    opacity: 0.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 26,
    r: 4,
    fill: "#f59e0b",
    filter: "url(#glow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 30,
    r: 4,
    fill: "#f59e0b",
    filter: "url(#glow)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 40,
    r: 4,
    fill: "#f59e0b",
    filter: "url(#glow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 22 26 Q 28 24 31 30",
    stroke: "#f59e0b",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 18 30 Q 20 35 19 36",
    stroke: "#f59e0b",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 35 34 Q 30 37 27 40",
    stroke: "#f59e0b",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 33,
    width: 44,
    height: 32,
    rx: 4,
    ry: 4,
    fill: "url(#bgGradient2)",
    stroke: "#3b82f6",
    strokeWidth: 1.5,
    filter: "url(#dropShadow)",
    opacity: 0.95
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 39,
    width: 14,
    height: 2.5,
    rx: 1.25,
    fill: "#3b82f6",
    opacity: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 43,
    width: 20,
    height: 2.5,
    rx: 1.25,
    fill: "#3b82f6",
    opacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 47,
    width: 10,
    height: 2.5,
    rx: 1.25,
    fill: "#3b82f6",
    opacity: 0.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 51,
    width: 17,
    height: 2.5,
    rx: 1.25,
    fill: "#3b82f6",
    opacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 55,
    width: 12,
    height: 2.5,
    rx: 1.25,
    fill: "#3b82f6",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 44,
    r: 2.5,
    fill: "#3b82f6",
    opacity: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 53,
    r: 2.5,
    fill: "#3b82f6",
    opacity: 0.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 48,
    width: 42,
    height: 37,
    rx: 4,
    ry: 4,
    fill: "url(#bgGradient3)",
    stroke: "#e2e8f0",
    strokeWidth: 2,
    filter: "url(#dropShadow)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 53,
    width: 22,
    height: 4,
    rx: 2,
    fill: "#1f2937"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 60,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#6b7280",
    opacity: 0.8
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 64,
    width: 27,
    height: 2,
    rx: 1,
    fill: "#6b7280",
    opacity: 0.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 68,
    width: 30,
    height: 2,
    rx: 1,
    fill: "#6b7280",
    opacity: 0.7
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 72,
    width: 22,
    height: 2,
    rx: 1,
    fill: "#6b7280",
    opacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 76,
    width: 34,
    height: 2,
    rx: 1,
    fill: "#6b7280",
    opacity: 0.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 80,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#6b7280",
    opacity: 0.6
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 68,
    width: 30,
    height: 2,
    rx: 1,
    fill: "#fbbf24",
    opacity: 0.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 76,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#10b981",
    opacity: 0.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 55,
    r: 4,
    fill: "#10b981",
    filter: "url(#glow)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 74 55 L 75.5 56.5 L 78 53.5",
    stroke: "#ffffff",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 42 35 Q 52 25 62 35",
    stroke: "#a855f7",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.6,
    strokeDasharray: "3,3",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 50 Q 65 40 75 50",
    stroke: "#a855f7",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.6,
    strokeDasharray: "3,3",
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 1.5,
    fill: "#f59e0b",
    opacity: 0.3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 25,
    r: 1,
    fill: "#3b82f6",
    opacity: 0.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 85,
    r: 1.5,
    fill: "#10b981",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleSessionsIcon);
export default __webpack_public_path__ + "static/media/multiple_sessions_icon.60786c10f63297ac8e195e7599e0d587.svg";
export { ForwardRef as ReactComponent };